module.exports = __WEBPACK_EXTERNAL_MODULE_228__;


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 228
// module chunks = 0